import { WhitelabelId } from '@whitelabel/WhitelabelId';
import { ULTheme, ULThemeBuilder } from './types';
import JapanicanThemeBuilder from './japanican';
import RurubuThemeBuilder from './rurubu';
import PricelineThemeBuilder from './priceline';
import AgodaThemeBuilder from './agoda';
import CitiThemeBuilder from '@theme/citi';
import RocketmilesThemeBuilder from '@theme/rocketmiles';
import WikibuyThemeBuilder from './wikibuy';
import HotelstormThemeBuilder from './hotelstorm';

export class ThemeFactory {
    public static getTheme(id: WhitelabelId, cultureCode: string, appId: string): ULTheme {
        return this.getThemeBuilder(id)(cultureCode, appId);
    }

    // TODO: Right now everything is bundled
    private static getThemeBuilder(id: WhitelabelId): ULThemeBuilder {
        switch (id) {
            case WhitelabelId.CITIUS:
            case WhitelabelId.CITIUSUAT1:
            case WhitelabelId.CITIUSUAT2:
            case WhitelabelId.CITIUSUAT3:
                return CitiThemeBuilder;
            case WhitelabelId.JAPANICAN:
            case WhitelabelId.JAPANICANUAT:
            case WhitelabelId.JTB:
            case WhitelabelId.JTBUAT:
                return JapanicanThemeBuilder;
            case WhitelabelId.RURUBU:
            case WhitelabelId.RURUBUUAT:
                return RurubuThemeBuilder;
            case WhitelabelId.PRICELINE:
                return PricelineThemeBuilder;
            case WhitelabelId.ROCKETMILES:
            case WhitelabelId.ROCKETMILESUAT:
                return RocketmilesThemeBuilder;
            case WhitelabelId.WIKIBUY:
                return WikibuyThemeBuilder;
            case WhitelabelId.HOTELSTORM:
                return HotelstormThemeBuilder;
            case WhitelabelId.AGODA:
            case WhitelabelId.AGODAUAT:
            default:
                return AgodaThemeBuilder;
        }
    }
}
